import { bool, string, node, object, func, arrayOf, oneOf, oneOfType, number } from "prop-types";
import { observer } from "mobx-react";
import { BreakdownTableDepths } from "@repo/utils";
import { SortableList } from "@components";
import { SummaryRowGroup } from "./SummaryRowGroup/SummaryRowGroup";
import { SummaryNestedRow } from "./SummaryNestedRow/SummaryNestedRow";

export const SummaryRowGroupList = observer(({
  isLastGroupRow,
  listElements,
  disabled,
  onReorder,
  children,
  hashedPath,
  tableDepth = BreakdownTableDepths.SECTION,
  ...elementProps
}) => {
  return (
    <>
      <SortableList
        list={listElements}
        path={hashedPath.join("/")}
        group={hashedPath.join("/")}
        onListReorder={onReorder}
        displayAsColumnFlexbox
        disabled={disabled}
      >
        {
          listElements?.map((child, i) => (
            tableDepth
              ? <SummaryNestedRow
                key={`element${i}${child.id}`}
                resource={child}
                isLastGroupRow={isLastGroupRow && i === listElements.length - 1}
                {...elementProps}
              />
              : <SummaryRowGroup
                key={`element${i}${child.id}`}
                workType={child}
                {...elementProps}
              />
          ))
        }
      </SortableList>
      {children}
    </>
  );
});

SummaryRowGroupList.propTypes = {
  tableDepth: oneOf([
    BreakdownTableDepths.SECTION,
    BreakdownTableDepths.MODULE,
    BreakdownTableDepths.FEATURE,
    BreakdownTableDepths.TASK,
  ]),
  listElements: arrayOf(object),
  onReorder: func,
  disabled: bool,
  isLastGroupRow: bool,
  hashedPath: arrayOf(oneOfType([number, string])),
  children: node,
};
